import React, { useState, useEffect } from "react";
import { Form, Button, Select, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from 'moment';
import * as zoneActions from "../../../../../redux/actions/zone.actions";
import * as actionPage from "../../../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const dateFormat = 'YYYY-MM-DD hh:mm:ss a';

const MartLevelFilter = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  
  useEffect(() => {
    if (props.pageFilter){
      form.setFieldsValue(props.pageFilter);
    }
  }, [props.pageFilter])

  useEffect(() => {
    postLists()
  }, []);

  const postLists = async() => {
    try {
      setLoading(true);      
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {zoneData.push({value: item?.id, label: item?.zoneName})});
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const filterChange = async (value) => {
    let newData ={
      ...props.pageFilter,
      ...value,
    }
    await props.actionPage.martFilterAction(newData);
  }


  const resetSearch = async (e) => {
    const d = moment().format("YYYY-MM-DD")
    const newData = {
      start_date: moment(d + ' ' + '08:00:00', dateFormat ),
      end_date: moment(d + ' ' + '03:00:00', dateFormat).add(1, 'days'),
    };
    form.resetFields();
    await props.actionPage.martFilterAction(newData);
  };

  return (
    <Form form={form} className="fliters_form" disabled={props?.pageLoading} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', }}>
      <Form.Item
       name={["zoneIds"]}
       label={'Zone'}
       rules={[{required: true, message: "Please select Value"}]}
      >
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          style={{ minWidth: 300,}}
        />
      </Form.Item>
      <Form.Item
       name={["start_date"]}
       label={"Start Date Time"}
      >
        <DatePicker
            format="YYYY-MM-DD hh:mm:ss a"
            showTime={{
              defaultValue: moment("00:00:00", "HH:mm:ss"),
            }}
        />
      </Form.Item>
      <Form.Item
       name={["end_date"]}
       label={"End Date Time"}
      >
        <DatePicker
            format="YYYY-MM-DD hh:mm:ss a"
            showTime={{
              defaultValue: moment("00:00:00", "HH:mm:ss"),
            }}
        />
      </Form.Item>
      <Button htmlType="submit" loading={props?.pageLoading}>Search <SearchOutlined /></Button>
      <Button loading={props?.pageLoading} onClick={()=>resetSearch()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoading: state.DashboardReducer.shiftDashboardLoader,
    pageFilter: state.DashboardReducer.martDashboardFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MartLevelFilter);

